





















import Vue from 'vue';

export default Vue.extend({
  name: 'FooterTeipTable',
  props: {
    from: {
      required: true,
      type: Number,
    },
    to: {
      required: true,
      type: Number,
    },
    total: {
      required: true,
      type: Number,
    },
    perPage: {
      required: true,
      type: Number,
    },
    currentPage: {
      required: true,
      type: Number,
    },
    table: {
      required: false,
      default: 'registros',
      type: String,
    },
  },
  methods: {
    paginationChanged(page: number): void {
      this.$emit('change', page);
    },
  },
  computed: {
    fromSync: {
      get(): number {
        return this.from;
      },
      set(value: number): void {
        this.$emit('update:from', value);
      },
    },
    toSync: {
      get(): number {
        return this.to;
      },
      set(value: number): void {
        this.$emit('update:to', value);
      },
    },
    totalSync: {
      get(): number {
        return this.total;
      },
      set(value: number): void {
        this.$emit('update:total', value);
      },
    },
    perPageSync: {
      get(): number {
        return this.perPage;
      },
      set(value: number): void {
        this.$emit('update:perPage', value);
      },
    },
    currentPageSync: {
      get(): number {
        return this.currentPage;
      },
      set(value: number): void {
        this.$emit('update:currentPage', value);
      },
    },
    tableSync: {
      get(): string {
        return this.table;
      },
      set(value: string): void {
        this.$emit('update:table', value);
      },
    },
  },
});
